import { useEffect, useState } from "react";
import { selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";

export function useOptometryHistory(patientId, range, type = "") {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarHistoricoOptometrias.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: patientId,
      completo: range,
      tipoFicha: type,
    });
    setList(response);
  }

  useEffect(() => {
    getData();
  }, [patientId, range, type]);

  return list;
}
